<div *ngIf="!isCompanyLoading" class="apt-main">
  <div class="apt-main-body" [ngClass]="{'flex-center-center':!isFirstTimeLoad}">
    <div class="appointment-request content-center row" [hidden]="!isFirstTimeLoad" *ngIf="companySetting">
      <div class="col-12 p-0">
        <div class="apt-header-wrapper mb-4 pb-3">
          <div class="company-logo-wrapper" *ngIf="companyLogo">
            <img [src]="companyLogo" alt="AutoLeap Logo" class="company-logo">
          </div>
          <div class="heading">
            <div class="appointment-heading">
              <h2 class="mb-0">{{companySetting.name}}</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="appointment-body col-12">
        <!-- <div class="heading">
          <div class="appointment-heading">
            <h3 *ngIf="isApptRequestPortalEnabled" class="mb-0">Appointment Booking Form</h3>
          </div>
        </div> -->

        <div class="flex-start-center justify-content-between px-md-0 px-3">
          <div class="w-100" [ngClass]="fourthStepper ? 'flex-end-center' : 'flex-between-center'">
            <div class="apt-icon-text-heading-wrapper" *ngIf="!fourthStepper">
              <div class="calendar-bg">
                <i *ngIf="firstStepper" class="fal fa-calendar-alt"></i>
                <i *ngIf="secondStepper" class="far fa-user"></i>
                <i *ngIf="thirdStepper && company" class="fal fa-calendar-check"></i>
              </div>
              <div>
                <div class="time-slot sub-heading">
                  <h3 *ngIf="firstStepper" class="mb-0">Select Services</h3>
                  <h3 *ngIf="secondStepper" class="mb-0">Select a time slot</h3>
                  <h3 *ngIf="thirdStepper && company" class="mb-0">Appointment details</h3>
                  <!-- <p>{{'appointment.tell-us-your-preferred-time-to-visit-our-workshop'|translate}}</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="campaign && campaign.showLeadSource" class="flex-center-center">
          <div class="lead-source d-flex p-2">
            <div class="m-icon">
              <i class="fal fa-megaphone"></i>
            </div>
            <!-- <p class="mb-0 pl-2 pr-1">Source:</p> -->
            <b>{{campaign.title}}</b>
          </div>

        </div>

        <div class="slidecontainer" *ngIf="isApptRequestPortalEnabled">
          <div class="slider">
            <div class="selected-slider"
              [ngClass]="[secondStepper?'width-50':thirdStepper?'width-75':fourthStepper?'width-100':'']">
              <!-- :fourthStepper?'width-100' -->
            </div>
          </div>
        </div>
        <div class="card" *ngIf="isApptRequestPortalEnabled">
          <div class="card-body">
            <!-- First Step -->

            <div [hidden]="!firstStepper || !company">
              <!-- <div class="d-flex">
                <div class="calendar-bg">
                  <i class="fal fa-calendar-alt"></i>
                </div>
                <div>
                  <div class="time-slot sub-heading">
                    <h3>Select Services</h3>
                    <p>Choose all services which may apply to your vehicle</p>
                  </div>
                </div>
              </div> -->
              <div class="step-wizard thirdStepper">
                <div class="otpinfo">
                  <div class="time-slot sub-heading mt-3 mt-md-4" *ngIf="customerDetails?.isVehicleMandatory">
                    <h3>Optional information</h3>
                  </div>
                  <div class="single-info">
                    <div class="opt-info-dd">
                      <div class="info-title flex-between-start" hidden (click)="onSelectService()">
                        <h3>
                          <i class="far gray-55 mr-2"
                            [ngClass]="[showServiceDropdown?'fa-chevron-down':'fa-chevron-right']"></i>
                          <span *ngIf="!serviceText && !isSelectedService">Add services</span>
                          <span *ngIf="serviceText">Services added</span>
                        </h3>
                        <i class="fas fa-check-circle" *ngIf="serviceText"></i>
                      </div>
                      <div class="ser-dd">
                        <div class="service-dd">
                          <div class="font-13 font-600 font-gray-45 px-2 pb-2 labor-suggestion-label"
                            *ngFor="let category of serviceCategories;let catIndex = index">
                            <p class="mb-0 font-black font-16 font-600">{{category.name}}</p>

                            <div class="ddl-empty-state-wrapper d-flex w-100 py-2 pl-3"
                              *ngFor="let service of category.services;let i = index">
                              <div class="empty-list-icon font-16 font-gray-75 pr-2 align-self-center">
                                <app-checkbox label="" [isChecked]="service.isHidden"
                                  (appChange)="handleCheckboxChange(catIndex,i,service, $event)">
                                </app-checkbox>
                              </div>

                              <div class="empty-list-text">
                                <p class="mb-0 font-16 font-400">
                                  {{service.name}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="errors.serviceValidation" class="apperror p-top-5">{{errors.serviceValidation}}
                        </div>
                        <div class="ui-g-12 form-field mt-5 textarea">
                          <div class="form-icon">
                            <!-- <i class="fal fa-tools gray-55"></i> -->
                          </div>
                          <div class="input-box">
                            <div class="font-12 gray-35 add-vehicle" [ngClass]="{ 'active': focus?.notes }">
                              Please describe the problem
                            </div>
                            <app-textarea placeholder="" theme="border" [rows]="4"
                              placeholder="Or describe your problem here.... "
                              (appChange)="handleChangeName('notes',$event)" [value]="userInfo.notes"
                              (appFocus)="handleFocus('notes')" (appBlur)="handleBlur('notes')"
                              [isInvalid]="errors?.notes" [errorMessage]="errors?.notes">
                            </app-textarea>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="mb-5"></div>
              </div>
            </div>

            <!-- Second Step -->
            <div [hidden]="!secondStepper">
              <div class="step-wizard second-stepper">
                <div class="sub-heading">
                  <h4>Select preferred date</h4>
                </div>
                <div class="justify-content-center" [hidden]="isFindingActiveWeek">
                  <app-date-filter [period]="activeView" [selectedDateTime]="defaultStartDate"
                    (appChange)="handleDateChange($event)" [currentLang]="currentLang" [token]="token"
                    [minimumDate]="minimumDate" [isPeriodSelectionVisible]="isCustomerView">
                  </app-date-filter>
                </div>

                <div *ngIf="isFindingActiveWeek" class="loading-spinner">
                  <i class="fas fa-spinner fa-spin"></i>
                  Loading available dates...
                </div>

                <div class="date-time-slider mt-4" [hidden]="isFindingActiveWeek">
                  <div class="box-section" #target>
                    <!-- [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'selectedDay':'',!day.isDisable?'not-allowed':'']" -->
                    <div class="day-box pointer" #dayBox *ngFor="let day of daysOfWeek;let i = index"
                      (click)="onDaySelect(day,null,true)" [ngClass]="{
                        'selectedDay': day.isDisable && (day.day | date:'yyyy-MM-dd') === (userInfo?.selectedDay?.day | date:'yyyy-MM-dd'),
                        'not-allowed': !day.isDisable
                      }">
                      <!-- ,day.isDisable?'not-allowed':'' -->
                      <div class="month-date-day">{{day.day | date:'EEE'}}</div>
                      <div class="black month-date">{{day.day | date:'d'}}</div>
                      <div class="month-name-wrapper">{{(day.day | date:'MMM')}}</div>
                    </div>
                  </div>
                </div>

                <div *ngIf="errors.selectDay" class="apperror p-top-5">{{errors.selectDay}}</div>

                <div class="sub-heading mt-4" [hidden]="isFindingActiveWeek"
                  *ngIf="selectedDay && selectedDay.length>0">
                  <h4>Select preferred time</h4>
                </div>
                <div class="mb-4">
                  <div class="time-for" *ngIf="selectedDay && selectedDay.length>0">
                    <div class="p-0 set-time day-breakdown-wrapper" *ngFor="let day of availableDates"
                      [ngClass]="{'d-none':day.hrs && day.hrs.length === 0}">
                      <div *ngIf="day.hrs && day.hrs.length > 0" (click)="onTimeCategorySelect(day)"
                        class="day-button pointer"
                        [ngClass]="{'selectedTime':selectedTimeCategory.length>0 && selectedTimeCategory[0] === day.name}">
                        <span class="for-selected-day">
                          {{day.name}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="time-off" *ngIf="selectedTimeCategory && selectedTimeCategory.length>0">
                    <div class="day-button pointer" *ngFor="let day of timeSlot" (click)="onTimeSlotSelect(day)"
                      [ngClass]="{
                      'selectedTime': (selectedTimeSlot.length > 0 && selectedTimeSlot[0] === day.value) || (selectedTimeSlot.length === 0 && i === 0)
                    }">
                      {{day.hr}}
                    </div>
                  </div>
                  <div *ngIf="errors.selectTime && selectedDay && selectedDay.length>0" class="apperror">
                    {{errors.selectTime}}
                  </div>
                </div>

                <div *ngIf="customerDetails?.isVehicleDropOffVisible">
                  <div class="sub-heading mb-4">
                    <h4>Will you be dropping off your vehicle?</h4>
                  </div>
                  <div>
                    <div class="mt-3" *ngFor="let radio of dropOffs">
                      <app-radio-button class="droppin-vehicle" name="droppin-vehicle" [label]="radio"
                        (appChange)="handleChangeDropOff(radio)" [selectedValue]="userInfo.vehicleDropoff"
                        [value]="radio"> </app-radio-button>
                    </div>
                    <div *ngIf="errors.dropOff" class="apperror">{{errors.dropOff}}</div>
                  </div>
                </div>

                <div class="text-center contact-us mt-4 mb-2">
                  Please call us at <a href="tel:{{companySetting?.phone}}" class="font-bold ">{{companySetting?.phone |
                    mask:'(000) 000-0000'}}</a>
                  if you require our services urgently!
                </div>
              </div>

            </div>


            <!-- Third Step -->
            <div *ngIf="thirdStepper">
              <div>
                <!-- <div class="d-flex">
                  <div class="calendar-bg">
                    <i class="far fa-calendar-check "></i>
                  </div>
                  <div>
                    <div class="time-slot sub-heading">
                      <h3>Appointment details</h3>
                      <p>Please review date and service information</p>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="c-appt-info thirdStepper">
                <div class="user-info">
                  <div class="calendar-bg">
                    <i class="far fa-calendar-check "></i>
                  </div>
                  <div class="time-slot sub-heading font-14">
                    <h5>
                      {{userInfo?.selectedDay?.day | date: 'MMM d, yyyy'}}
                      &nbsp;-&nbsp;{{userInfo.selectedTime.hr}}
                    </h5>
                  </div>
                </div>
                <div class="user-info width-100" *ngIf="selectedService && selectedService.length > 0">
                  <div class="calendar-bg">
                    <i class="far fa-tools "></i>
                  </div>
                  <div>
                    <div class="time-slot sub-heading font-14">
                      <h5>
                        Services
                      </h5>
                    </div>
                    <div class="mt-2 service-row">
                      <div *ngFor="let service of selectedService;let i = index" class="chip">
                        {{service}}<span *ngIf="selectedService.length - 1 > i"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="d-flex mt-20">
                <div class="calendar-bg">
                  <i class="far fa-user"></i>
                </div>
                <div>
                  <div class="time-slot sub-heading">
                    <h3>Enter your details</h3>
                    <p>Please provide your name and contact details</p>
                  </div>
                </div>
              </div> -->
              <div class="step-wizard second-stepper">
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-user"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="first-name" validationId="error-first-name" placeholder="First name*"
                      [floatingLabel]="true" [maxLength]="25" (appChange)="handleChangeName('firstName',$event)"
                      [isInvalid]="errors?.firstName" [value]="userInfo.firstName" [errorMessage]="errors?.firstName">
                    </app-input>
                  </div>
                </div>

                <!-- Last name -->
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-user"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="last-name" validationId="error-last-name" placeholder="Last name*"
                      [floatingLabel]="true" [maxLength]="25" (appChange)="handleChangeName('lastName',$event)"
                      [value]="userInfo.lastName" [isInvalid]="errors?.lastName" [errorMessage]="errors?.lastName">
                    </app-input>
                  </div>
                </div>

                <!-- Contact number -->
                <div class="ui-g-12 p-0">
                  <div class="ui-g-12 form-field mb-0">
                    <div class="form-icon">
                      <!-- <i class="fal fa-mobile gray-55"></i> -->
                      <i class="fas fa-mobile-alt gray-55"></i>
                    </div>
                    <div class="input-box">
                      <app-input id="phone" validationId="error-phone" placeholder="Primary Mobile number*"
                        [isInvalid]="errors?.phone" [errorMessage]="errors?.phone" mask="(000) 000-0000"
                        [floatingLabel]="true" (appChange)="handleChangeName('phone',$event)" [value]="userInfo.phone">
                      </app-input>
                    </div>
                  </div>
                  <label class="gray-55 mb-3 font-12 mt-3" [ngClass]="{'mt-3':errors?.phone}">
                    Please provide mobile # so you could receive confirmation SMS
                  </label>
                </div>

                <!-- Email -->
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-envelope gray-55"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="email" type="text" placeholder="Primary email" style="flex: 0 0 275px;"
                      maxlength="50" [fontSize]="14" [errorMessage]="errors.email" [isInvalid]="errors.email"
                      [floatingLabel]="true" [value]="userInfo.email" (appChange)="handleChangeName('email',$event)">
                    </app-input>
                  </div>
                </div>

                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-car gray-55 font-18"></i>
                  </div>
                  <div class="single-info w-100">
                    <div class="opt-info-dd">
                      <div>
                        <div class="p-0 input-field mt-2">
                          <app-auto-complete id="ac-vehicle" listId="ac-vehicle-list" label="Vehicle" itemWidth="100%"
                            theme="primary" noRecordIcon="far fa-car  font-16 pr-2"
                            noRecordText="No vehicle match your search" [placeholder]="vehicleSearchPlaceholder"
                            [textTruncate]="true" [fontSize]="14" [suggestions]="vehicleSuggestions"
                            [floatingLabel]="true" [hasCustomEditableField]="focus?.vehicle || query?.vehicle"
                            [autoFocus]="focus?.vehicle" [isInvalid]="errors?.vehicle" [errorMessage]="errors?.vehicle"
                            [isLoading]="isLoading" [value]="vehicle?.title" [closeOnSelection]="true"
                            (appCompletedMethod)="onSearchVehicle($event)" (appClickInput)="handleFocus('vehicle')"
                            (appClickOutside)="handleBlur('vehicle')" [hasCustomListTemplate]="true"
                            (appChange)="handleChange('vehicle', $event)" (appClear)="onSuggestionsClear('vehicle')"
                            scrollHeight="186px">
                            <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close"
                              appTemplate="list">
                              <li class="loading text-center p-3" *ngIf="isLoading">
                                <i class="fas fa-spinner fa-spin mr-2"></i> Searching...
                              </li>
                              <li class="no-record-found text-left p-2"
                                *ngIf="vehicleSuggestions?.length === 0 && isVehicleSearchTriggered && !isLoading">
                                No searches found
                              </li>
                              <li class="font-12 font-600 p-2 bt-1 source-suggestions-label active-vehicle-header"
                                *ngIf="vehicleType?.active?.length > 0">
                                <p class="mb-0">Active vehicles</p>
                              </li>
                              <li class="source-suggestions-local">
                                <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                                  <li class="font-12 font-black p-2 source-suggestion-label"
                                    *ngFor="let item of vehicleType?.active; let i = index" id="item-{{ i }}"
                                    (click)="onVehicleSelect(item, close)">
                                    <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                                      <div class="flex-between-center">
                                        <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                                          [innerHTML]="item?.htmlLicensePlate">
                                        </p>
                                        <p class="m-0" [innerHTML]="item?.htmlName"></p>
                                      </div>

                                      <div class="flex-between-center">
                                        <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                                        <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin"
                                          [innerHTML]="item?.htmlVin"></p>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>

                              <li class="font-12 font-600 p-2 bt-1 source-suggestions-label in-active-header"
                                *ngIf="vehicleType.inactive?.length > 0">
                                <p class="mb-0">Inactive vehicles</p>
                              </li>
                              <li class="source-suggestions-local in-active-list">
                                <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                                  <li class="font-12 font-black p-2 source-suggestion-label archived"
                                    *ngFor="let item of vehicleType?.inactive; let j = index" id="item-{{ j }}">
                                    <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                                      <div class="flex-between-center">
                                        <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                                          [innerHTML]="item?.htmlLicensePlate">
                                        </p>
                                        <p class="m-0" [innerHTML]="item?.htmlName"></p>
                                      </div>

                                      <div class="flex-between-center">
                                        <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                                        <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin"
                                          [innerHTML]="item?.htmlVin"></p>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                            </ng-template>

                            <ng-template appTemplate="editable">
                              <div id="create-vehicle" class="width-100p" (click)="openCreateVehicle()">
                                <span class="font-700 font-16"
                                  [hidden]="vehicleSuggestions?.length === 0 && isVehicleSearchTriggered && !isLoading">
                                  Add vehicle +
                                </span>
                                <span class="font-700 font-16"
                                  *ngIf="vehicleSuggestions?.length === 0 && isVehicleSearchTriggered && !isLoading">
                                  Add vehicle details +
                                </span>
                              </div>
                            </ng-template>
                          </app-auto-complete>
                        </div>
                        <div class="ui-g-12 input-row vehicle-row mb-1 overflow-scroll px-0"
                          [hidden]="!isCreateVehicleMode">
                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <app-input id="v-year" type="text" theme="primary" placeholder="Year *" [fontSize]="14"
                              [floatingLabel]="true" [value]="vehicle?.year" [mask]="'0000'" [isInvalid]="errors?.year"
                              [errorMessage]="errors?.year" [autoFocus]="isCreateVehicleMode"
                              (appChange)="handleChange('year', $event)">
                            </app-input>
                          </div>

                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <app-input id="v-make" type="text" theme="primary" placeholder="Make*" [maxLength]="35"
                              [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.make" [isInvalid]="errors?.make"
                              [errorMessage]="errors?.make" (appChange)="handleChange('make', $event)">
                            </app-input>
                          </div>

                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <app-input id="v-model" type="text" theme="primary" placeholder="Model*" [maxLength]="35"
                              [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.model"
                              [isInvalid]="errors?.model" [errorMessage]="errors?.model"
                              (appChange)="handleChange('model', $event)">
                            </app-input>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="errors.selectVehicle" class="apperror mt-1">{{errors.selectVehicle}}</div>
                    </div>
                  </div>
                </div>

                <!-- Adding consent checkboxes -->
                <div class="ui-g-12 form-field mb-1">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <app-checkbox inputId="apt-sms-template"
                      [label]="'Yes, I consent to receive Appointment reminders, Service updates, and other informational messages via SMS from ' + companySetting?.name + '.'"
                      [isChecked]="isOperationalNotifEnabled"
                      (appChange)="handleChangeName('isOperationalNotifEnabled', $event === true || $event === 'true')">
                    </app-checkbox>
                  </div>

                </div>

                <!-- Discount/promotional consent checkbox -->
                <div class="ui-g-12 form-field mb-1">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <app-checkbox inputId="apt-discount-template"
                      [label]="'Yes, I consent to receive promotional offers, discounts, and marketing messages via SMS from ' + companySetting?.name + '.'"
                      [isChecked]="isMarketingNotifEnabled"
                      (appChange)="handleChangeName('isMarketingNotifEnabled', $event === true || $event === 'true')">
                    </app-checkbox>
                  </div>
                </div>

                <!-- Privacy policy -->
                <div class="ui-g-12 form-field">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <p class="font-10">
                      By providing your mobile number and selecting the checkbox above, you agree to receive SMS
                      messages based on your selected preferences. Your information will be kept confidential and will
                      not be shared. For more details, please review our
                      <a class="primary-500" [routerLink]="['/customer-appointment-request/privacy-policy', token]"
                        target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Fourth Step -->
            <div *ngIf="fourthStepper">
              <div class="step-wizard mt-0">
                <div>
                  <div class="time-slot sub-heading">
                    <h3>Thank you for choosing {{companySetting.name}}!</h3>
                    <p>We have received your booking for <strong>{{userInfo?.selectedDay?.day | date: 'MMM d, yyyy'}} at
                        {{confirmedDate | date:'h:mmaa'}}</strong>. Here is your booking id: <strong>{{code}}</strong>.
                      We will reach out to you soon with a
                      confirmation.</p>

                  </div>
                </div>
              </div>
              <div class="fourthStepper">
                <div class="mt-3">
                  <div class="c-appt-info">
                    <div class="user-info width-100">
                      <div class="calendar-bg">
                        <i class="far fa-calendar-check "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>
                            {{userInfo?.selectedDay?.day | date: 'MMM d, yyyy'}}
                            &nbsp;-&nbsp;{{userInfo.selectedTime.hr}}
                          </h5>
                          <p>
                            Booking ID: APR#{{code}}
                            <span class="mx-2">|</span>
                            <ng-container *ngIf="userInfo?.vehicleDropoff === dropOffs[1]">{{dropOffs[1]}}
                            </ng-container>
                            <ng-container *ngIf="userInfo?.vehicleDropoff === dropOffs[0]">{{dropOffs[0]}}
                            </ng-container>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100">
                      <div class="calendar-bg">
                        <i class="far fa-user "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>{{userInfo?.firstName}} {{userInfo?.lastName}}</h5>
                          <p>{{userInfo?.phone}}&nbsp;{{userInfo?.email?"| ":""}}{{userInfo?.email}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100" *ngIf="selectVehicle && selectVehicle != 'Select Vehicle'">
                      <div class="calendar-bg">
                        <i class="far fa-car "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>{{selectVehicle}}</h5>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100" *ngIf="showServiceName && showServiceName.length > 0">
                      <div class="calendar-bg">
                        <i class="far fa-tools "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>

                            <ng-container *ngFor="let service of showServiceName;let i = index">
                              {{service}}<span *ngIf="showServiceName.length - 1 > i">,</span>
                            </ng-container>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Footer buttons  -->
          <div class="footer-buttons" *ngIf="!fourthStepper">
            <div class="single-btn" *ngIf="!firstStepper">
              <button class="btn btn-lg btn-outline-secondary" (click)="onBackStepper()">
                Previous
              </button>
            </div>
            <div class="single-btn" *ngIf="!thirdStepper">
              <button class="btn btn-lg btn-primary" (click)="onNextStepper()">
                Next
              </button>
            </div>
            <div class="single-btn" *ngIf="thirdStepper">
              <button class="btn btn-lg btn-primary" (click)="onConfirmRequest()">
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isApptRequestPortalEnabled" class="no-request">
      <div class="not-found mt-3 text-center">
        No times are currently available!
      </div>
      <div class="gray-45 font-18 mt-3 text-center">
        Please
        <a href="tel:{{companySetting?.phone}}">contact </a>the shop directly to schedule an appointment.
      </div>
      <div class="mt-5 flex-center-center">
        <img src="assets/no-request.jpg" class="not-found-img" />
      </div>
    </div>
    <div>
      <i *ngIf="!isFirstTimeLoad" class="rotate fas fa-spinner font-40"></i>
    </div>
  </div>

  <div class="apt-main-footer" *ngIf="isFirstTimeLoad">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="contact-sec">
            <p class="mb-1">
              <i class="far fa-phone-alt font-secondary-500"></i>
              <a class="font-secondary-500" href="tel:{{companySetting?.phone}}">{{companySetting?.phone | mask:'(000)
                000-0000'}}</a>
            </p>
            <p *ngIf="customerDetails.isShopAddress">
              <i class="far fa-map-pin font-secondary-500"></i>
              <a href="http://maps.google.com/?q={{companySetting.fullAddress}}"
                class="font-secondary-500 text-underline" target="_blank">{{companySetting.fullAddress}}</a>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <!-- <div class="footer-brand">
            <p class="mr-2">Powered by</p>
            <img src="assets/autoleap-green.png" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="dummy-tech-iphone-height"></div>
</div>
